import { CommonRootState } from '../combineReducers';
import { DeepReadonly } from 'utility-types';
import { RootActions } from '../combineActions';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';

const namespace = 'aion-ui-options';

const getOptions = () => {
  const options =
    window && window.localStorage && window.localStorage.getItem(namespace)
      ? JSON.parse(window.localStorage.getItem(namespace) as string)
      : {};

  return {
    type: 'GET_OPTIONS',
    options
  } as const;
};

export const getOptionsAsync = (): ThunkAction<Promise<void>, CommonRootState, null, Actions> => dispatch => {
  return new Promise(async (resolve, reject) => {
    try {
      dispatch(getOptions());
      resolve();
    } catch (error) {
      reject(error);
    }
  });
};

export const setOption = (key: string, value: any) => (
  dispatch: ThunkDispatch<CommonRootState, null, RootActions>,
  getState: () => CommonRootState
) => {
  if (window && window.localStorage) {
    const options = { ...getState().options };
    options[key] = value;
    window.localStorage.setItem(namespace, JSON.stringify(options));
  }

  dispatch({
    type: 'SET_OPTION',
    option: { [key]: value }
  } as const);
};

export const toggleStringPresenceInArray = (array: DeepReadonly<string[]> = [], value: string) => {
  const newArray = [...array];
  const existingIndex = newArray.indexOf(value);
  if (existingIndex > -1) {
    newArray.splice(existingIndex, 1);
  } else {
    newArray.push(value);
  }
  return newArray;
};

export const toggleNavExpanded = (): ThunkAction<void, CommonRootState, null, RootActions> => (dispatch, getState) => {
  const { navExpanded } = getState().options;

  return dispatch(setOption('navExpanded', !navExpanded));
};

export const toggleNavExpandedSectionId = (
  sectionId: string
): ThunkAction<void, CommonRootState, null, RootActions> => (dispatch, getState) => {
  const { navExpanded, navExpandedSectionIds: ids } = getState().options;

  if (!navExpanded) {
    dispatch(setOption('navExpanded', true));
    return dispatch(setOption('navExpandedSectionIds', [sectionId]));
  } else {
    const newIds = toggleStringPresenceInArray(ids, sectionId);
    return dispatch(setOption('navExpandedSectionIds', newIds));
  }
};

const shouldGetOptions = ({ options: { isLoaded } }: CommonRootState) => !isLoaded;

export const getOptionsIfNeeded = (): ThunkAction<void, CommonRootState, null, RootActions> => (dispatch, getState) => {
  if (shouldGetOptions(getState())) {
    dispatch(getOptionsAsync());
  }
};

export type Actions =
  | ReturnType<typeof getOptions>
  | {
      type: 'SET_OPTION';
      option: {};
    };
